export default [
	{
		key: 'sponsor.name',
		title: 'Sponsor Name',
		scopedSlots: {customRender: 'sponsor'}
	}, {
		key: 'biller_disbursement_account.biller.contact_name',
		title: 'Biller',
		scopedSlots: {customRender: 'billerName'}
	}, {
		key: 'biller_disbursement_account.product_group.name',
		title: 'Product Group',
		scopedSlots: {customRender: 'productGroupName'}
	}, {
		key: 'sponsor_account',
		title: 'Sponsor Account',
		scopedSlots: {customRender: 'sponsorAccount'}
	}, {
		key: 'sponsor_fee',
		title: 'Sponsor Fee',
		scopedSlots: {customRender: 'sponsorFee'}
	}, {
		dataIndex: 'updated_at',
		key: 'updatedAt',
		title: 'Last Updated',
		scopedSlots: {customRender: 'updatedAt'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 150,
		scopedSlots: {customRender: 'action'}
	}
]
